import PopupContext from "../../../../context/context-popup";
import DateTimeInputPopup from "./popup";

import { useContext, useEffect, useState } from "react";

import LabelContainer from "../../../../components/label-container";
import dayjs from "dayjs";
import { getDSTLocalTime } from "../../../../lib/helpers/datetime-helpers";

export default function DateTimeInput({
    label = '',
    value = '',
    onChange = () => {},
    space,
    readOnly = false,
    data
}) {
    const {
        start,
        morning_session,
        afternoon_session,
    } = value;

    const { setPopup } = useContext(PopupContext);

    const to = start ? `${getDSTLocalTime(start).format('DD/MM/YY')}` : 'DD/MM/YY';
    let from = `Nothing Selected`;

    if (morning_session == true) {
        from = 'Morning'
    }

    if (afternoon_session == true) {
        from = 'Afternoon'
    }

    if (morning_session == true && afternoon_session == true) {
        from = 'All Day'
    }

    const onClick = (e) => {
        e.preventDefault();

        if (!readOnly) setPopup(<DateTimeInputPopup onChange={onChange} space={space} value={value} data={data} />);
    }

    return (
        <LabelContainer label={label}>
            <div className={`date-time-picker ${readOnly ? 'date-time-picker--readonly' : ''}`} onClick={onClick}>
                <div className="date-time-picker__date">{ to }</div>
                <div className="date-time-picker__time">{ from }</div>
            </div>
        </LabelContainer>
    )
}